<template>
    <div class="image" v-on:click="selectImage">
        <img class="profile-image" v-show="image" v-bind:src="image" />
    </div>
</template>

<script>
import { blobToDataUrl } from "../../../../helpers/files";

export default {
    props: {
        input: HTMLInputElement,
    },
    data() {
        return {
            image: null,
        };
    },
    methods: {
        selectImage() {
            this.input.click();
        },
    },
    mounted() {
        const self = this;

        this.input.onchange = function () {
            const file = this.files[0];

            blobToDataUrl(file).then((value) => (self.image = value));
        };
    },
};
</script>

<style lang="scss" scoped>
.image {
    width: 70px;
    height: 70px;
    border-radius: 100%;
    position: relative;
    overflow: hidden;
    background: #e6ebed;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        cursor: pointer;
    }

    img {
        width: 100%;
    }
}
</style>
